import { branch, renderNothing } from 'recompose'
import { createStructuredSelector } from 'reselect'

import { Route } from 'i18n/utils'
import { withRouteParams } from 'shared/hoc'

import { activeTabSelector } from '../selectors'

const Breadcrumb = ({ title, path, active }) => (
    <li className={`breadcrumb-item ${active ? 'active' : ''}`}>{active ? title : <Link to={path}>{title}</Link>}</li>
)

const $ActiveBreadcrumb = ({ tab }) => <Breadcrumb title={tab.label} />

const ActiveBreadcrumb = compose(
    withRouteParams,
    connect(
        createStructuredSelector({
            tab: activeTabSelector,
        })
    ),
    branch(props => !props.tab, renderNothing)
)($ActiveBreadcrumb)

const Breadcrumbs = ({ location }) => (
    <ol className="breadcrumb">
        <Breadcrumb title={<T>onstreet.locations.title</T>} path={`/on-street`} />
        <Breadcrumb title={location.name} path={`/on-street/${location.slug}`} />
        <Route path="/on-street/:slug/:pageId" component={ActiveBreadcrumb} />
    </ol>
)

export default Breadcrumbs
